import React from 'react';
import {useSurveyError} from '../../contexts/SurveyErrorContext';
import styles from './SurveyErrorDisplay.module.css';

export const SurveyErrorDisplay: React.FC = () => {
  const {error} = useSurveyError();

  if (!error) {
    return null;
  }

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorMessage}>Error: {error}</div>
    </div>
  );
};
